import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from '@/i18n';
import { Card } from '@/components/Shared/Card';
import { Button } from '@/components/Shared/Button';
import { FileUpload } from '@/components/Shared/FileUpload';
import { useNetzplanImportStore } from '@/store/useNetzplanImportStore';

export function UploadStep() {
  const { t } = useTranslation('import');
  const { loadFromFile, loading, error } = useNetzplanImportStore();
  const [files, setFiles] = useState<File[]>([]);

  return (
    <Card>
      <div className="space-y-4">
        <p className="text-[13px] text-slate-600">{t('upload.intro')}</p>

        <FileUpload
          label={t('upload.fileLabel')}
          accept=".xlsx,.xlsm"
          files={files}
          onChange={setFiles}
          helperText={t('upload.fileHint')}
        />

        {error && (
          <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-[12px] text-red-700">
            <AlertTriangle className="w-4 h-4 shrink-0 mt-px" strokeWidth={2} />
            <span>{error}</span>
          </div>
        )}

        <div className="flex justify-end">
          <Button
            onClick={() => files[0] && loadFromFile(files[0])}
            disabled={!files[0]}
            loading={loading}
          >
            {loading ? t('upload.parsing') : t('actions.analyze')}
          </Button>
        </div>
      </div>
    </Card>
  );
}

export default UploadStep;
